import isEmpty from 'lodash/isEmpty'
import compact from 'lodash/compact'
import get from 'lodash/get'

import { getDefaultSellerId } from '@/checkout-instore-legacy/seller/utils'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import { getOrderFormId } from '@/checkout-instore-legacy/utils/orderFormUtils'
import {
  addParamsToQueryString,
  isVtexAppPath,
  myVtexUrl,
} from '@/checkout-instore-legacy/utils/UrlUtils'
import { isMobileNativePlatform } from '@/checkout-instore-legacy/device/utils'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

import { WHATSAPP_SEND_URI, WHATSAPP_OPEN_URI } from './constants'

function getSavedHostName() {
  const instoreHostName = get(getInstoreConfig(), ['socialShare', 'hostName'])
  const hostName = get(getReduxStore().getState(), ['share', 'hostName'])
  return instoreHostName || hostName || window.location.host
}

function getExternalBaseUrl() {
  return `${window.location.protocol}//${getSavedHostName()}`
}

export function getEcommerceIframeUrl() {
  return `${window.location.protocol}//${window.location.host}/`
}

function getWhatsappLink(text: string) {
  if (isMobileNativePlatform()) {
    return addParamsToQueryString(WHATSAPP_SEND_URI, {
      text,
    })
  }

  return addParamsToQueryString(WHATSAPP_OPEN_URI, {
    text,
  })
}

function getItemParams(item: any) {
  if (isEmpty(item)) {
    return ''
  }

  const seller = item.seller || getDefaultSellerId()
  const quantity = item.quantity || 1
  const sku = item.id || item.sku || ''

  if (isEmpty(sku)) {
    return ''
  }

  return `sku=${sku}&qty=${quantity}&seller=${seller}`
}

function getItemsParams(items: Item[]) {
  if (isEmpty(items)) {
    return []
  }

  return compact(items.map((item) => getItemParams(item)))
}

export function getRelativeItemsLink(orderForm: OrderForm) {
  const items = get(orderForm, 'items', [])
  const itemsParams = getItemsParams(items)

  if (isEmpty(itemsParams)) {
    return ''
  }

  return `/checkout/cart/add?${itemsParams.join('&')}`
}

export function getAbsoluteItemsLink(orderForm: OrderForm) {
  return `${getExternalBaseUrl()}${getRelativeItemsLink(orderForm)}`
}

export function getWhatsappItemsLink(orderForm: OrderForm) {
  return getWhatsappLink(getAbsoluteItemsLink(orderForm))
}

export function getRelativeOrderFormLink(orderForm: OrderForm) {
  const orderFormId = getOrderFormId(orderForm)
  return `/checkout/?orderFormId=${orderFormId}`
}

export function getAbsoluteOrderFormLink(orderForm: OrderForm) {
  return `${getExternalBaseUrl()}${getRelativeOrderFormLink(orderForm)}`
}

export function getRelativeShareLink(shareCode: string) {
  return `/api/io/_v/share/${shareCode}`
}

export function getAbsoluteShareLink(shareCode: string) {
  if (isVtexAppPath()) {
    return `${myVtexUrl()}${getRelativeShareLink(shareCode)}`
  }

  return `${getExternalBaseUrl()}${getRelativeShareLink(shareCode)}`
}

export function getAbsolutePaymentLink(shareCode: string) {
  return `${getAbsoluteShareLink(shareCode)}?step=payment`
}

export function getWhatsappOrderFormLink(
  orderForm: OrderForm,
  message: string
) {
  const orderLink = getAbsoluteOrderFormLink(orderForm)
  const completeMessage = `${message} \n ${orderLink}`
  const wppLink = getWhatsappLink(completeMessage)
  return wppLink
}

export function getCompleteMessageShareable(
  shareCode: string,
  message: string
) {
  const shareLink = getAbsoluteShareLink(shareCode)
  const completeMessage = `${message} \n ${shareLink}`
  return completeMessage
}

export function getWhatsappShareCartLink(shareCode: string, message: string) {
  const completeMessage = getCompleteMessageShareable(shareCode, message)
  return getWhatsappLink(completeMessage)
}

export function getWhatsappPaymentLink(shareCode: string, message: string) {
  const paymentLink = getAbsolutePaymentLink(shareCode)
  const completeMessage = `${message} \n ${paymentLink}`
  return getWhatsappLink(completeMessage)
}
